import { Component, OnInit, OnDestroy } from '@angular/core';
import { faPencilAlt, faSearch, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { RolesService } from 'src/app/shared/services/admin-services/roles.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { ProductRole } from 'src/app/shared/models/admin-models/product-role.model';
import { ProductRoleService } from 'src/app/shared/services/admin-services/product-role.service';

@Component({
  selector: 'app-product-roles',
  templateUrl: './product-roles.component.html',
  styleUrls: ['./product-roles.component.sass']
})
export class ProductRolesComponent implements OnInit, OnDestroy {
  faSearch = faSearch;
  faPencilAlt = faPencilAlt;
  faTrashAlt = faTrashAlt;
  faCheck = faCheck;
  faTimes = faTimes;

  roles: Observable<Array<{ name: string, id: number }>>;
  productType: Observable<any>;
  addOrEditBool: Boolean = false;

  productTypeID: Number;
  productRoleID: Number;

  productForm = new FormGroup({
    productType: new FormControl('', [Validators.required]),
    productRole: new FormControl('', [Validators.required]),
    allowMultiClients: new FormControl(false, []),
    maxClientPerRole: new FormControl({ value: '', disabled: true })
  })

  constructor(private modalService: NgbModal, private roleService: RolesService, private productRoleService: ProductRoleService) { }

  firstProgram;
  secondProgram;
  thirdProgram;
  forthProgram;
  fifthProgram;
  sixthProgram;
  seventhProgram;
  eightProgram;
  ninghtProgram;
  tenthProgram;
  eleventhProgram;

  ngOnInit() {
    this.getAll();
  }

  ngOnDestroy() {

  }

  getAll() {
    this.productType = this.productRoleService.gridView();
    this.roles = this.roleService.gridView();
    this.firstProgram = this.productRoleService.getRoleByProduct(0)
    this.productRoleService.getRoleByProduct(0)
      .subscribe(
        (res) => {
          console.log(res)
        }
      );
    this.secondProgram = this.productRoleService.getRoleByProduct(1);
    this.productRoleService.getRoleByProduct(1)
    this.thirdProgram = this.productRoleService.getRoleByProduct(2);
    this.forthProgram = this.productRoleService.getRoleByProduct(3);
    this.fifthProgram = this.productRoleService.getRoleByProduct(4);
    this.sixthProgram = this.productRoleService.getRoleByProduct(5);
    this.seventhProgram = this.productRoleService.getRoleByProduct(6);
    this.eightProgram = this.productRoleService.getRoleByProduct(7);
    this.ninghtProgram = this.productRoleService.getRoleByProduct(8);
    this.tenthProgram = this.productRoleService.getRoleByProduct(9);
    this.eleventhProgram = this.productRoleService.getRoleByProduct(11);
  }

  openAddProductTypeModal(modal) {
    this.addOrEditBool = true
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' })
    this.productForm.reset({ allowMultiClients: false });
  }
  addProductRole() {
    if (!this.productForm.invalid) {
      let product = new ProductRole({ ProductType: parseInt(this.productForm.value.productType), ProductRoleID: this.productForm.value.productRole, AllowMultipleClients: this.productForm.value.allowMultiClients })
      if (this.productForm.value.allowMultiClients) {
        if (this.productForm.value.maxClientPerRole) {
          product.data.MaxClientsPerRole = this.productForm.value.maxClientPerRole;
          // console.log(product)
          this.productRoleService.createProductRole(product)
            .then(
              x => {
                this.modalService.dismissAll();
                this.getAll();
              }
            )
        } else {

        }
      } else {
        product.data.MaxClientsPerRole = 0;
        // console.log(product)
        this.productRoleService.createProductRole(product)
          .then(
            x => {
              this.modalService.dismissAll();
              this.getAll();
            }
          )
      }
    } else {
      // console.log("Doesnt work");
    }
  }

  editProductRole() {

  }

  openDeleteProduct(num1, num2, modal) {
    this.productTypeID = num1;
    this.productRoleID = num2;
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' })
  }
  deleteProduct() {
    this.productRoleService.deleteProductRole(this.productTypeID, this.productRoleID)
      .subscribe(
        x => {
          this.modalService.dismissAll();
          this.getAll();
        }
      )
  }

  changeAllow() {

    if (this.productForm.value.allowMultiClients) {
      this.productForm.controls['maxClientPerRole'].enable();
    } else {
      this.productForm.controls['maxClientPerRole'].disable();
    }
  }

}
